import { useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./TopFiveLocationsSlide.styles";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { BarsChartFunctionalLocations } from "components/BarsChartFunctionalLocations/BarsChartFunctionalLocations.view";
import { IGraphProps } from "./interfaces";
import { NoStatsDataSlide } from "../index";
import { buildLocationsChartData } from "./locationsTransforms";

export const TopFiveLocationsSlide = ({
    downtimeEvents,
    countryCode,
}: Pick<IGraphProps, "downtimeEvents" | "countryCode">) => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const { displayUnit } = useContext(HMIContext);

    const { hasData, barsChartData } = useMemo(
        () => buildLocationsChartData(downtimeEvents, displayUnit, i18n.language, countryCode),
        [downtimeEvents, countryCode, displayUnit, i18n.language],
    );

    return (
        <Box className={classes.slideRoot}>
            <Typography variant="h1" className={classes.title}>
                {t("HMI.top_five_functional_locations.title")}
            </Typography>
            {hasData ? (
                <Grid container className={classes.graphContainer}>
                    <Grid item xs={12} className={classes.graphGridItemContainer}>
                        <BarsChartFunctionalLocations data={barsChartData} />
                    </Grid>
                </Grid>
            ) : (
                <NoStatsDataSlide />
            )}
        </Box>
    );
};
